import { Injectable } from '@angular/core';

import { AuthHttp } from 'angular2-jwt';

const API_ROOT = 'https://app.fastnetbeta.com/';

@Injectable()
export class HttpAPIWrapper{
  constructor(private http: AuthHttp) {}

  private apiRoot = API_ROOT;

  head(url: string): any{
    return this.http.head(`${this.apiRoot}${url}`);
  }

  get(url: string, options): any{
    return this.http.get(`${this.apiRoot}${url}`, options);
  }

  post(url: string, options): any{
    return this.http.post(`${this.apiRoot}${url}`, options);
  }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-router-loader/src!./~/angular2-template-loader!./src/app/shared/helpers/http-api-wrapper.ts
 **/